<template>
  <div class="d-flex justify-content-center align-items-center">
    <div style="width: 95%">
      <router-link class="btn btn-info m-1" :to="`/dashboard/role-management`"
        >Back</router-link
      >
      <card class="card border" style="padding: 10px; margin-top: 8px">
        <div class="form-body" v-if="dataLoaded">
          <input
            v-model="role.role"
            class="form-control"
            placeholder="Role Name"
            style="
              font-size: 1.5em;
              font-weight: bold;
              text-transform: uppercase;
            "
          />
          <div class="table-body">
            <card class="card-plain">
              <div class="table-full-width table-responsive">
                <table class="table">
                  <thead class="thead-dark">
                    <tr>
                      <th scope="col">Permission</th>
                      <th scope="col">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(permission, index) in allPermissions"
                      :key="index"
                      class="data-row"
                    >
                      <td>{{ permission.permission.toUpperCase() }}</td>
                      <td class="text-left">
                        <ul>
                          <li
                            v-for="(action, i) in permission.actions"
                            :key="i"
                          >
                            <input
                              type="checkbox"
                              :checked="
                                isChecked(permission.permission, action)
                              "
                              @change="
                                togglePermission(permission.permission, action)
                              "
                            />
                            {{ action }}
                          </li>
                        </ul>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </card>
          </div>
          <div class="btns">
            <button
              class="btn btn-info m-2"
              @click="deleteRole(role)"
              style="background-color: rgb(217, 16, 16); border: none"
            >
              <i class="ti-trash"></i>Delete
            </button>
            <button class="btn btn-info m-2" @click="updateRole(role)">
              <i class="ti-save"></i>Update
            </button>
          </div>
        </div>
        <div v-else>
          <p>Loading...</p>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import axios from "../store/axios";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      role: {},
      rolePermissions: [],
      allPermissions: [],
      updatedPermissions: {},
      dataLoaded: false,
    };
  },
  mounted() {
    const roleId = this.$route.params.id;
    Promise.all([this.fetchAllPermissions(), this.fetchRolePermissions(roleId)])
      .then(() => {
        this.initializePermissions();
        this.dataLoaded = true;
      })
      .catch((error) => {
        console.error("Error fetching permissions", error);
      });
  },
  methods: {
    fetchAllPermissions() {
      return axios
        .get(`${process.env.VUE_APP_API_URL}/permission`)
        .then((response) => {
          if (response.data && response.data.roleAndPermissions) {
            const permissionsArray =
              response.data.roleAndPermissions[0].permissions;

            this.allPermissions = permissionsArray.map((perm) => ({
              permission: Object.keys(perm)[0],
              actions: perm[Object.keys(perm)[0]],
            }));
          } else {
            console.error("Invalid data format for all permissions");
          }
        });
    },
    fetchRolePermissions(roleId) {
      return axios
        .get(`${process.env.VUE_APP_API_URL}/role/${roleId}`)
        .then((response) => {
          if (response.data && response.data.role) {
            this.role = response.data.role;
            this.rolePermissions = response.data.role.permissions || [];
            // console.log("Role Permissions:", this.rolePermissions);
          }
        });
    },
    initializePermissions() {
      this.allPermissions.forEach((permission) => {
        this.$set(this.updatedPermissions, permission.permission, {});
        permission.actions.forEach((action) => {
          this.$set(
            this.updatedPermissions[permission.permission],
            action,
            this.rolePermissions.some(
              (rolePermission) =>
                rolePermission.permission === permission.permission &&
                rolePermission.actions.includes(action),
            ),
          );
        });
      });
      // console.log("Updated Permissions:", this.updatedPermissions);
    },
    isChecked(permission, action) {
      return (
        this.updatedPermissions[permission] &&
        this.updatedPermissions[permission][action]
      );
    },
    togglePermission(permission, action) {
      if (!this.updatedPermissions[permission]) {
        this.$set(this.updatedPermissions, permission, {});
      }
      this.$set(
        this.updatedPermissions[permission],
        action,
        !this.isChecked(permission, action),
      );
    },
    updateRole(role) {
      const updatedPermissionsArray = Object.keys(this.updatedPermissions).map(
        (permission) => ({
          permission,
          actions: Object.keys(this.updatedPermissions[permission]).filter(
            (action) => this.updatedPermissions[permission][action],
          ),
        }),
      );
      axios
        .post(`${process.env.VUE_APP_API_URL}/role/update/${role._id}`, {
          role: role.role,
          permissions: updatedPermissionsArray,
        })
        .then((response) => {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Role updated successfully",
          }).then(() => {
            this.$router.push("/dashboard/role-management");
          });
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Error updating role",
          });
          console.error("Error updating role", error);
        });
    },
    deleteRole(role) {
      Swal.fire({
        title: "Are you sure?",
        text: `Are you sure you want to delete the role "${role.role.toUpperCase()}" and its permissions? This action cannot be reversed.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "Cancel",
      }).then((result) => {
        if (result.isConfirmed) {
          axios
            .delete(`${process.env.VUE_APP_API_URL}/role/delete/${role._id}`)
            .then((res) => {
              Swal.fire({
                icon: "success",
                title: "Deleted",
                text: "Role deleted successfully",
              }).then(() => {
                this.$router.push("/dashboard/role-management");
              });
            })
            .catch((err) => {
              Swal.fire({
                icon: "error",
                title: "Error",
                text: "Unable to delete role",
              });
              console.log(err);
            });
        }
      });
    },
  },
};
</script>

<style></style>
